import React, { useMemo } from "react";
import { StatusFilterType } from "@pages/Dashboard/contexts/Filter.context";
import { getStatusFilterOptions } from "@src/common/hooks/useStatusGantt";
import FilterAccordion, { FilterOption } from "../FilterAccordion";

interface StatusFilterProps {
  selectedFilters: StatusFilterType[];
  onChange: (variant: StatusFilterType, checked: boolean) => void;
}

const StatusFilter: React.FC<StatusFilterProps> = ({
  selectedFilters,
  onChange,
}) => {
  const options: FilterOption[] = useMemo(() => {
    return getStatusFilterOptions().map((option) => ({
      value: option.value,
      label: option.label,
    }));
  }, []);

  return (
    <FilterAccordion
      title="Status"
      options={options}
      selectedValues={selectedFilters}
      onChange={onChange}
    />
  );
};

export default StatusFilter;
